// @flow
import { CertificacionesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    certificacion: {},
    listaCertificaciones: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type CertificacionesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { certificacion?: {} | null, listaCertificaciones?: [] | null, loading?: boolean, +value ?: boolean };

const Certificaciones = (state: State = INIT_STATE, action: CertificacionesAction): any => {
    // console.log(action);
    switch (action.type) {
        case CertificacionesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case CertificacionesActionTypes.GET_CERTIFICACION: {
                    return {
                        ...state,
                        certificacion: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CertificacionesActionTypes.LIST_CERTIFICACIONES: {
                    return {
                        ...state,
                        listaCertificaciones: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CertificacionesActionTypes.ADD_CERTIFICACION: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CertificacionesActionTypes.UPDATE_CERTIFICACION: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CertificacionesActionTypes.DELETE_CERTIFICACION: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CertificacionesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case CertificacionesActionTypes.GET_CERTIFICACION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        certificacion: {},
                        loading: false,
                    };
                }
                case CertificacionesActionTypes.LIST_CERTIFICACIONES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaCertificaciones: [],
                        loading: false,
                    };
                }
                case CertificacionesActionTypes.ADD_CERTIFICACION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CertificacionesActionTypes.UPDATE_CERTIFICACION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CertificacionesActionTypes.DELETE_CERTIFICACION: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CertificacionesActionTypes.GET_CERTIFICACION:
            return { ...state, error: false, loading: true };
        case CertificacionesActionTypes.LIST_CERTIFICACIONES:
            return { ...state, error: false, loading: true };
        case CertificacionesActionTypes.ADD_CERTIFICACION:
            return { ...state, error: false, loadingForm: true };
        case CertificacionesActionTypes.UPDATE_CERTIFICACION:
            return { ...state, error: false, loadingForm: true };
        case CertificacionesActionTypes.DELETE_CERTIFICACION:
            return { ...state, error: false, loading: true };
        case CertificacionesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                certificacion: {},
                listaCertificaciones: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Certificaciones;
